import {z} from 'zod';

import {isConfiguredBalloonVariant} from '../utils/isConfiguredBalloonVariant';
import {addRatePairIssues} from './addRatePairIssues';
import {financingRateSchema} from './financingRateSchema';

const balloonVariantSchema = z
  .object({
    balloonPayment: z.number(),
    nominalRate: financingRateSchema.nullable(),
    apr: financingRateSchema.nullable(),
  })
  .superRefine(addRatePairIssues);

export const balloonFinancingCellFormSchema = z
  .object({
    variants: z.array(balloonVariantSchema),
    activeBalloonPayment: z.number().nullable(),
  })
  .refine((values) => values.variants.some(isConfiguredBalloonVariant), {path: ['variants']});

export type BalloonFinancingCellFormValues = z.infer<typeof balloonFinancingCellFormSchema>;
